import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  listPickList: [],
  pickListEdit: null,
  pickListParentOptions: null,
  loadingPicklist: false,
  loadingGetDetail: false,
  loadingPicklistDelete: false,
  rowInput: {},
  picklistID: "",
  objectID: "",
  subscriberPicklist: null,
  listFieldSub: [],
  // keySearch
};

const slice = createSlice({
  name: "dropList",
  initialState,
  reducers: {
    getListPicklist() {},
    getListPicklistSuccess(state, action) {
      state.listPickList = action.payload;
    },
    getPicklist(state, action) {
      state.loadingGetDetail = true;
    },
    getPicklistSuccess(state, action) {
      state.pickListEdit = action.payload;
      state.loadingGetDetail = false;
      state.objectID = _.get(action, "payload.object_id");
      state.picklistID = _.get(action, "payload._id");
    },
    getParentPicklist(state, action) {},
    getParentPicklistSuccess(state, action) {
      state.pickListParentOptions = action.payload;
    },
    createPickList(state, action) {
      state.loadingPicklist = true;
    },
    createPickListSuccess(state, action) {
      state.loadingPicklist = false;
      state.picklistID = action.payload;
    },
    addOption(state, action) {},
    addOptionSuccess(state, action) {},
    editPickList(state, action) {
      state.loadingPicklist = true;
    },
    editPickListSuccess(state, action) {
      state.loadingPicklist = false;
      state.pickListEdit = { ...state.pickListEdit, name: action.payload };
    },
    editParentPickList(state, action) {
      state.loadingPicklist = true;
    },
    editParentPickListSuccess(state, action) {
      state.loadingPicklist = false;
    },
    actionOptionPicklist(state, action) {
      state.loadingPicklistDelete = true;
    },
    actionOptionPicklistSuccess(state, action) {
      state.loadingPicklistDelete = false;
    },
    deletePicklist(state, action) {
      state.loadingPicklistDelete = true;
    },
    deletePicklistSuccess(state, action) {
      state.loadingPicklistDelete = false;
    },
    setRowInput(state, action) {
      state.rowInput = action.payload;
    },
    setObjectID(state, action) {
      state.objectID = action.payload;
    },
    resetDroplistState(state, action) {
      state.rowInput = {};
      state.pickListEdit = null;
      state.pickListParentOptions = null;
      state.picklistID = "";
      state.objectID = "";
    },
    getSubscriberPicklist() {},
    getSubscriberPicklistSuccess(state, action) {},
    getFieldSub() {},
    getFieldSubSuccess(state, action) {
      state.listFieldSub = action.payload;
    },
  },
});

export default slice.reducer;

//Action
export const {
  getFieldSub,
  getFieldSubSuccess,
  getSubscriberPicklist,
  getSubscriberPicklistSuccess,
  getListPicklist,
  getListPicklistSuccess,
  getPicklist,
  getPicklistSuccess,
  createPickList,
  createPickListSuccess,
  editPickList,
  editPickListSuccess,
  actionOptionPicklist,
  actionOptionPicklistSuccess,
  deletePicklist,
  deletePicklistSuccess,
  setRowInput,
  addOption,
  addOptionSuccess,
  setObjectID,
  editParentPickList,
  editParentPickListSuccess,
  getParentPicklist,
  getParentPicklistSuccess,
  resetDroplistState,
} = slice.actions;
